import { resetStateBuilder } from './helperReducers';
import { createSlice } from '@reduxjs/toolkit';
import { fetchPerfHist, fetchPerfHistPerf } from '../api';
const initialState = {
    isLoaded: false,
    loading: false,
    obj_datas: {
        data_ini: '',
        data_fim: '',
        data_ini2: '',
        datas_nao_uteis: '',
        data_mais_antiga_portfolio_AAAAmmDD: '',
        data_mais_recente_portfolio_AAAAmmDD: '',
    },
    dadosMesaMes: [],
    graficoRetornos: [],
    graficoPL: [],
    movimentacoes: [],
    rendimento12meses: {},
    selectedBenchmarks: null,
    loadingPercent: false,
};
export const perfHistSlice = createSlice({
    name: 'perfHist',
    initialState,
    reducers: {
        setSelectedBenchmarksPerfHist: (state, action) => {
            // se estiver carregado com os benchmarks null, foram utilizados os benchmarks do CV_bench_mes_a_mes
            if (state.isLoaded && state.selectedBenchmarks !== null) {
                state.selectedBenchmarks = action.payload;
                if (state.selectedBenchmarks === action.payload) {
                    state.isLoaded = false;
                }
            }
            else { // se j� estiver carregado com os benchs da preferencia, n�o recarregar
                state.selectedBenchmarks = action.payload;
            }
        },
        resetSelectedBenchmarksPerfHist: (state) => {
            state.selectedBenchmarks = initialState.selectedBenchmarks;
        },
    },
    extraReducers: (builder) => {
        resetStateBuilder(builder, initialState, ['selectedBenchmarks']);
        builder.addCase(fetchPerfHist.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(fetchPerfHist.fulfilled, (state, action) => {
            var _a, _b, _c, _d, _e, _f;
            state.loading = false;
            state.isLoaded = true;
            state.obj_datas = (_a = action.payload.PerfHist) === null || _a === void 0 ? void 0 : _a.obj_datas;
            state.dadosMesaMes = (_b = action.payload.PerfHist) === null || _b === void 0 ? void 0 : _b.dadosMesaMes;
            state.graficoRetornos = (_c = action.payload.PerfHist) === null || _c === void 0 ? void 0 : _c.grafico_retornos;
            state.graficoPL = (_d = action.payload.PerfHist) === null || _d === void 0 ? void 0 : _d.grafico_pl;
            state.movimentacoes = (_e = action.payload.PerfHist) === null || _e === void 0 ? void 0 : _e.movimentacoes;
            state.rendimento12meses = (_f = action.payload.PerfHist) === null || _f === void 0 ? void 0 : _f.rendimento_12meses;
        });
        builder.addCase(fetchPerfHist.rejected, (state) => {
            state.loading = false;
        });
        builder.addCase(fetchPerfHistPerf.pending, (state) => {
            state.loadingPercent = true;
        });
        builder.addCase(fetchPerfHistPerf.fulfilled, (state, action) => {
            state.loadingPercent = false;
            state.dadosPercentPerf = action.payload.PerfHistPerf;
        });
        builder.addCase(fetchPerfHistPerf.rejected, (state) => {
            state.loadingPercent = false;
        });
    },
});
export const { setSelectedBenchmarksPerfHist, resetSelectedBenchmarksPerfHist } = perfHistSlice.actions;
// export const selectToken = (state: RootState) => state.preference.token;
export default perfHistSlice.reducer;
